<template>
  <div>
    <v-header :small="true"/>
    <login-form/>
  </div>
</template>

<script>
import LoginForm from "@/components/LoginForm.vue";
import VHeader from "@/components/header";

export default {
  components: {
    LoginForm,
    VHeader
  }
};
</script>
